import { Routes } from '@angular/router';

export const routes: Routes = [
	{
		path: '',
		loadComponent: () => import('./features/home/home').then((m) => m.Home),
		title: 'Aldorar Tour — Travel Umrah & Haji Terpercaya',
	},
	{
		path: 'paket',
		loadComponent: () => import('./features/packages/packages').then((m) => m.Packages),
		title: 'Paket Perjalanan — Aldorar Tour',
	},
	{
		path: 'paket/:id',
		loadComponent: () =>
			import('./features/package-detail/package-detail').then((m) => m.PackageDetailPage),
		title: 'Detail Paket — Aldorar Tour',
	},
	{
		path: 'blog',
		loadComponent: () => import('./features/blog/blog').then((m) => m.Blog),
		title: 'Blog & Artikel — Aldorar Tour',
	},
	{
		path: 'blog/:id',
		loadComponent: () => import('./features/blog-detail/blog-detail').then((m) => m.BlogDetail),
		title: 'Artikel — Aldorar Tour',
	},
	{
		path: 'hubungi-kami',
		loadComponent: () => import('./features/contact/contact').then((m) => m.Contact),
		title: 'Hubungi Kami — Aldorar Tour',
	},
	{
		path: 'syarat-ketentuan',
		loadComponent: () => import('./features/terms/terms').then((m) => m.Terms),
		title: 'Syarat & Ketentuan — Aldorar Tour',
	},
	{
		path: 'kebijakan-privasi',
		loadComponent: () => import('./features/privacy/privacy').then((m) => m.Privacy),
		title: 'Kebijakan Privasi — Aldorar Tour',
	},
	{
		path: 'lacak',
		loadComponent: () => import('./features/lacak/lacak').then((m) => m.Lacak),
		title: 'Lacak Booking — Aldorar Tour',
	},
	{
		path: 'portal',
		loadComponent: () => import('./features/portal/portal').then((m) => m.Portal),
		title: 'Portal Jamaah — Aldorar Tour',
	},
	{ path: '**', redirectTo: '' },
];
